import { useEffect, useState } from "react";
import Sparkle from "./Sparkle";

const LOGO_URL = "/brand/IMG_2238.PNG";

export const LoadingScreen = () => {
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 250);
    const t2 = setTimeout(() => setVisible(false), 700);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="loading-screen"
      className={`fixed inset-0 z-[100] bg-shay-navy flex items-center justify-center transition-opacity duration-700 ${
        fading ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* Scattered sparkles */}
      <Sparkle size={28} color="#C89A36" className="absolute top-[18%] left-[15%] opacity-80 animate-float-slow" />
      <Sparkle size={18} color="#C89A36" className="absolute top-[26%] right-[18%] opacity-70" />
      <Sparkle size={36} color="#C89A36" className="absolute bottom-[22%] left-[20%] opacity-60 animate-float-slow" />
      <Sparkle size={20} color="#C89A36" className="absolute bottom-[30%] right-[22%] opacity-70" />
      <Sparkle size={14} color="#C89A36" className="absolute top-[48%] left-[8%] opacity-60" />
      <Sparkle size={16} color="#C89A36" className="absolute top-[40%] right-[10%] opacity-60" />

      <div className="relative flex flex-col items-center">
        <div className="relative">
          <img
            src={LOGO_URL}
            alt="Shay Cooks LLC"
            className="h-44 md:h-56 w-auto select-none drop-shadow-[0_15px_40px_rgba(200,154,54,0.4)]"
            draggable={false}
          />
        </div>
        <div className="mt-8 flex items-center gap-3">
          <span className="h-px w-8 bg-shay-gold" />
          <p className="text-[10px] uppercase tracking-[0.4em] text-shay-gold">Baking Fresh</p>
          <span className="h-px w-8 bg-shay-gold" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
